import { FC } from "react";
import { Modal } from '@sainsburys-tech/luna-modal'
import { PopupType } from "../../../Interfaces/IModalProps";
import ProductFields from "./productFields";
import store from "../../../Store/store";
import { storePageDirtyPayload } from "../../../Redux/Actions/pageDirtyAction";

const ProductModal: FC<PopupType> = ({
    isOpen,
    handleClose,
    handleAddCallback: handleAdd,
    title,
    isEdit
}) => {

    const closeHandler = () => {
        store.dispatch(storePageDirtyPayload(null))
        handleClose(false)
    }

    return (
        <>
            <div className="duTypeModal">
                <Modal
                    classNanme="duTypeModal"
                    small
                    handleClose={() => closeHandler()}
                    open={isOpen}
                    headingId="info-modal"
                    stickyHeader="Sticky Header"
                    restrictClose={true}
                >
                    <ProductFields closeModal={closeHandler} isEdit={isEdit}/>
                </Modal>
            </div>
        </>
    )
}
export default ProductModal;